exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-3b884edb], h2[data-v-3b884edb] {\r\n  font-weight: normal;\n}\nul[data-v-3b884edb] {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli[data-v-3b884edb] {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na[data-v-3b884edb] {\r\n  color: #42b983;\n}\r\n", "", {"version":3,"sources":["D:/code/wdapp/src/components/HelloWorld.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,sBAAsB;EACtB,WAAW;CACZ;AACD;EACE,sBAAsB;EACtB,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"HelloWorld.vue","sourcesContent":["\nh1[data-v-3b884edb], h2[data-v-3b884edb] {\r\n  font-weight: normal;\n}\nul[data-v-3b884edb] {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli[data-v-3b884edb] {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na[data-v-3b884edb] {\r\n  color: #42b983;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b884edb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HelloWorld.vue
// module id = xGRF
// module chunks = 28